
<template>
    <el-cascader ref="area" :options="areaOption"  v-model="areaOptValue" :placeholder="placeholder" :change-on-select="true"   :props="{value: 'code',label:'name', children: 'children',emitPath:emitPath}" :clearable="clearable" separator="/"></el-cascader>   
</template>

<script>
    import area from './area.js';
    export default area;
</script>




